import axios from 'axios';
const baseURL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:3002/api' : 
  `${process.env.REACT_APP_URL}:${process.env.REACT_APP_PORT}/api`

const instance = axios.create({
  baseURL,
  crossDomain: true,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
});

export const makeFetch = options => instance(options);